import React from 'react';
import Highcharts from 'highcharts';
const ReactHighcharts = require('react-highcharts');
const HighchartsMore = require('highcharts-more');
HighchartsMore(ReactHighcharts.Highcharts);
const utils = require('./utils');

const plotLines = new Set();
const BORDER_COLOR = '#666666';
function yLabelFormatter(){
	if (window.selectedChartMetric) {
		const prefix = window.selectedChartMetric.name.indexOf('$')>=0?'$':window.selectedChartMetric.name.indexOf('%')>=0?'%':'';
		return prefix+this.value;
	} else {
		return this.value;
	}
}
var DEFAULT_HEIGHT = "20%";
var DEFAULT_X_FORMAT = "{value:%e-%b-%y}";
const EVENT_HANDLER = {
  allowPointSelect: true,
  // dataLabels: { enabled: true, color: 'white' },
  events: {
     // Default action for (left) clicking the data
     click: function(point) {
      const pp = new Date(point.point.options.x).getTime();
      if (plotLines.has(pp)) {
        plotLines.delete(pp);
        window.thechart.xAxis[0].removePlotLine(`milestone-${pp}`);
      } else {
        plotLines.add(pp);
        window.thechart.xAxis[0].addPlotLine({
          dashStyle: 'ShortDash',
          color: '#FF0000',
          width: 3,
          value: pp,
          id: `milestone-${pp}`
        });
      }
     }
  }
};
var chartConfig = {
  "chart": {
    "id": "DashboardChart",
    "renderTo": "container",
    "zoomType": "x",
    "height": DEFAULT_HEIGHT,
    "backgroundColor": "none",
    "borderColor": BORDER_COLOR,
    "borderWidth": 1
  },
  "time": {
    "useUTC": false
  },
  "title": {
    "text": "",
	"style": {
        "color": "#ffffff",
        "fontFamily": "Roboto, Helvetica, Arial, sans-serif",
        "fontSize": "12px"
      }
  },
  "subtitle": {
    "text": (function() { try { const b = JSON.parse(localStorage.getItem('nobid_branding')); return 'Source: ' + (b && b.copyright_text || 'NoBid, Inc.'); } catch(e) { return 'Source: NoBid, Inc.'; } })(),
	"style": {
        "fontFamily": "Roboto, Helvetica, Arial, sans-serif",
        "fontSize": "10px"
    }
  },
  "xAxis": {
    "type": "datetime",
    "labels": {
      "format": "{value:%e-%b-%y}",
      "style": {
        "color": "#ffffff",
        "fontFamily": "Roboto, Helvetica, Arial, sans-serif"
      }
    },
    "crosshair": true
  },
  "yAxis": [
    {
      // "labels": {
      //   "formatter": yLabelFormatter,
      //   "style": {
      //     "color": "#ffffff",
      //     "fontFamily": "Roboto, Helvetica, Arial, sans-serif"
      //   }
      // },
      stackaedLabels: {
        enabled: true,
        formatter: yLabelFormatter,
        style: {
          color: "#ffffff",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif"
        }
      },
      "title": {
        "text": "",
        "style": {
          "color": "#ffffff",
          "fontWeight": "bold",
          "fontFamily": "Roboto, Helvetica, Arial, sans-serif"
        }
      },
      "plotLines": [
        {
          "value": 0,
          "width": 3
        }
      ]
    }
  ],
  "rangeSelector": {
      "selected": 1
  },
  "series": [
    { 
    	"name": 'Revenue',
        "type": 'spline',
        "borderRadius": 0,
        "fillOpacity": 0.5,
        "shadow": false,
        "animation": Highcharts.svg,
        "marginRight": 10,
        "valuePrefix": "$",
        "tooltip": { "valuePrefix": "$", "valueSuffix": " USD"}
    }
  ],
  "tooltip": {
      "crosshairs": true,
      "shared": true
  },
  "legend": {
    "enabled": true,
    "layout": "vertical",
    "itemStyle": {
      "color": "#ffffff",
      "fontWeight": "bold",
      "fontFamily": "Roboto, Helvetica, Arial, sans-serif"
    },
    labelFormatter: function () {
      let legendDetails = '';
      if (this.data && this.data.length > 0) {
        const currency = this.name.startsWith('$') ? '$' : ' ';
        const count = utils.long(this.data.length, currency);
        let sum = 0;
        this.data.forEach(x => sum += x.y);
        const sumd = sum;
        sum = utils.double(sum, currency);
        const average = count>0 ? utils.double(sumd/this.data.length, currency) : 0;
        legendDetails = ` [Count: ${count} - Sum: ${sum} - Avg: ${average}]`;
      }
      return this.name + legendDetails;
    }
  },
  "plotOptions": {
    "series": {
      "turboThreshold": 5000,
    },
    column: EVENT_HANDLER,
    line: EVENT_HANDLER,
    area: EVENT_HANDLER,
    spline: EVENT_HANDLER,
    scatter: EVENT_HANDLER
  }
}
export class NoBidChartComponent extends React.Component {

  classChartConfig = {...chartConfig};

  state = {
	color: '',
	config: {}
  };
  constructor(props) {
    super(props);
    plotLines.clear();
    this.classChartConfig.chart.height = (props.config && props.config.height)?props.config.height:DEFAULT_HEIGHT;
    if (props.config && props.config.min) this.classChartConfig.yAxis[0].min = props.config.min;
    else delete this.classChartConfig.yAxis[0].min;
    if (props.config && props.config.xformat) this.classChartConfig.xAxis.labels.format = "{value:"+props.config.xformat+"}";
    else this.classChartConfig.xAxis.labels.format = DEFAULT_X_FORMAT;
    if (props.config && props.config.color) this.state.color = props.config.color;
    else this.state.color = '';
    this.state.config = props.config || {};
    window.selectedChartMetric = null;
    window.selectedChartFormat = null
    window.selectedThresholdLine = null;
    this.classChartConfig.series = props?.series || this.classChartConfig.series;
    this.classChartConfig.plotOptions = props?.plotOptions || this.classChartConfig.plotOptions;
    this.classChartConfig.legend = props?.legend || this.classChartConfig.legend;
    this.classChartConfig.title.text = props?.title || this.classChartConfig.title.text;
  }

  shouldComponentUpdate(nextProps, nextState) {    
    if (nextProps.update) {
      this.classChartConfig.series = nextProps?.series || this.classChartConfig.series;
      this.classChartConfig.plotOptions = nextProps?.plotOptions || this.classChartConfig.plotOptions;
      this.classChartConfig.legend = nextProps?.legend || this.classChartConfig.legend;
      this.classChartConfig.title.text = nextProps?.title || this.classChartConfig.title.text;
    }
    return nextProps.update || false;
  }

  clearChart () {
    const thechart = this.refs.chart.getChart();
    while (thechart.series.length) {
      thechart.series[0].remove();
    }
  }

  refreshChart(data, chartMetricsChoices, chartFormatChoices, options, force) {
    if (force) this.forceUpdate();
	  if (options && options.metric) window.selectedChartMetric = chartMetricsChoices.find(element => element.id===options.metric);
	  else if (!window.selectedChartMetric) window.selectedChartMetric = chartMetricsChoices[0];
	  
	  if (options && options.format) window.selectedChartFormat = chartFormatChoices.find(element => element.id===options.format);
    else if (!window.selectedChartFormat) window.selectedChartFormat = chartFormatChoices[0];

    if (options && options.thresholdLine) window.selectedThresholdLine = options.thresholdLine;
	  
	  let selectedChartMetric = window.selectedChartMetric;
	  let selectedChartFormat = window.selectedChartFormat;
    let selectedThresholdLine = window.selectedThresholdLine;
	  
	  let prefix  = selectedChartMetric && selectedChartMetric.name.indexOf('$')>=0?'$':selectedChartMetric && selectedChartMetric.name.indexOf('%')>=0?'%':'';
	  let suffix  = prefix==='$'?' USD':'';
	  let i = 0;
	  let series = {};
    let seriesCount = 0;
	  for (let i in data) {
      let item = data[i];
      let dateStr = item.date;
      if (typeof dateStr === 'string' && dateStr.length === 10) dateStr += 'T12:00:00';
      let x = new Date(dateStr);
      if (this.classChartConfig.xAxis.labels.format.indexOf('H')<=0) x = x.getTime();
		  let key = '';
      key = key + ((item.today)?item.today:'');
		  key = key + ((item.publisher_name)?item.publisher_name:'');
		  key = key + ((item.site_name)?' '+item.site_name:'');
		  key = key + ((item.bidder_name)?' '+item.bidder_name:'');
		  key = key + ((item.tldomain)?' '+item.tldomain:'');
		  key = key + ((item.device)?' '+item.device:'');
		  key = key + ((item.placement_name)?' '+item.placement_name:'');
		  key = key + ((item.adsize)?' '+item.adsize:'');
		  if (!series[key]) {
			  if (seriesCount>=20) continue;
			  seriesCount++;
			  series[key]= [];
		  }
      const value = item[selectedChartMetric.id];
      const serie = Array.isArray(value) ? {x:x, low: Number(Number(value[0]).toFixed(2)), high: Number(Number(value[1]).toFixed(2))}
        : {x:x, y: Number(Number(value).toFixed(2))}; 
      // const serie = {x:x, y: Array.isArray(value) ? value.map(x => Number(x).toFixed(2)) : Number(Number(value).toFixed(2))};
      if (item._color) serie._color = item._color;
      if (item._type) serie._type = item._type;
      if (item._zindex) serie._zindex = item._zindex;
      if (item._dataLabels) serie._dataLabels = item._dataLabels;
      if (item._opacity) serie._opacity = item._opacity;
      if (item._fillColor) serie._fillColor = item._fillColor;
		  series[key].push( serie );
      // series[key].push( {x:x, y: item.stack.map(x => Number(x['1'].value.toFixed(2)))} );
	  }

	  let thechart = this.refs.chart.getChart();
	  
	  window.thechart = thechart;
	  thechart.setTitle({text: selectedChartMetric.name});
 	  thechart.yAxis[0].setTitle({ text: selectedChartMetric.name }, false);
    thechart.yAxis[0].min = 0;
 	  
	  let c = 0;
    let defaultSeries = null;

	  for (let i in series) {
      let color = series[i]?.[0]?._color || this.state.color;
      let type = series[i]?.[0]?._type || selectedChartFormat.id;
      let zindex = series[i]?.[0]?._zindex;
      let dataLabels = series[i]?.[0]?._dataLabels;
      let opacity = series[i]?.[0]?._opacity || 1;
      let fillColor = series[i]?.[0]?._fillColor;

		  if (thechart.series[c]) {
        thechart.series[c].remove(true);
      }
		  c++;
      const seriesName = selectedChartMetric.name + ' ' + i;
      const serie = {
        name: seriesName,
        type: type,
        lineWidth: 2,
        allowDecimals: true,
        marker: { symbol: 'circle' },
        animation: Highcharts.svg,
        marginRight: 10,
        valueDecimals: 2,
        color: color,
        borderWidth: 0,
        valuePrefix: prefix,
        fillOpacity: opacity,
        tooltip: { 'valuePrefix': prefix, 'valueSuffix': suffix },
        data: series[i]
      };
      if (fillColor && type === 'area') serie.fillColor = fillColor;
      if (type === 'scatter') delete serie.lineWidth;
      if (zindex) serie.zIndex = zindex;
      if (dataLabels) serie.dataLabels = dataLabels;
      thechart.addSeries(serie, true);
      if (!defaultSeries) defaultSeries = series[i];
	  }
    const TLINE_NAME = 'threshold-line';
    if (selectedThresholdLine && Number(selectedThresholdLine) !== 0) {
      thechart.yAxis[0].removePlotLine(TLINE_NAME);
      thechart.yAxis[0].addPlotLine({
        color: '#FF0000',
        dashStyle: 'ShortDash',
        width: 3,
        value: Number(selectedThresholdLine),
        id: TLINE_NAME
      });
    }
    plotLines.forEach(plotLine => {
      thechart.xAxis[0].addPlotLine({
        color: '#FF0000',
        dashStyle: 'ShortDash',
        width: 3,
        value: plotLine,
        id: `milestone-${plotLine}`
      });
    });

	  thechart.redraw();
  }
  render() {
    return (
      <div>
	      <ReactHighcharts config={this.classChartConfig} ref="chart" domProps={{id: 'chartID'}}/>
	    </div>
    );
  }
}
